import { useEffect, useRef, useCallback } from "react";

export function useSyncHeight({
  scrollSelector = ".singleJourneyContent",
  element,
}) {
  const ref = useRef(null);

  const sync = useCallback(() => {
    const scrollArea = document.querySelector(scrollSelector);
    const target = ref.current;

    if (target && scrollArea) {
      target.style.height = "100%";
      const newHeight = scrollArea.scrollHeight;

      requestAnimationFrame(() => {
        if (target) target.style.height = `${newHeight}px`;
      });
    }
  }, [scrollSelector]);

  useEffect(() => {
    if (!element) return;

    const scrollArea = document.querySelector(scrollSelector);
    if (!scrollArea) return;

    const observer = new ResizeObserver(sync);
    observer.observe(scrollArea);
    observer.observe(document.body);

    sync();

    window.addEventListener("resize", sync);
    return () => {
      window.removeEventListener("resize", sync);
      observer.disconnect();
    };
  }, [sync, scrollSelector, element]);

  return ref;
}
